export enum EUserStatuses {
  'ACTIVE' = 1,
  'AWAIT' = 2,
}
